var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-10 col-sm-7 col-md-7 col-lg-7 image centered"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image.url,"alt":_vm.image.title}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }